import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { WORKSHOP_TYPES } from '../calculatorConstants';
import styles from '../Calculator.module.css';

interface StepWorkshopProps {
    selectedType: string;
    onSelect: (type: string) => void;
}

const StepWorkshop: React.FC<StepWorkshopProps> = ({ selectedType, onSelect }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.step}>
            <div className={styles.header}>
                <h3 className={styles.title}>{t('calculator.workshop.title')}</h3>
                <p className={styles.subtitle}>{t('calculator.workshop.subtitle')}</p>
            </div>
            <div className={styles.optionsContainer}>
                {WORKSHOP_TYPES.map((type, index) => (
                    <label
                        key={type}
                        className={`${styles.option} ${
                            selectedType === type ? styles.selected : ''
                        }`}
                    >
                        <input
                            type="radio"
                            name="workshopType"
                            checked={selectedType === type}
                            onChange={() => onSelect(type)}
                            className={styles.radio}
                        />
                        <span className={styles.radiomark}></span>
                        {t(`calculator.workshop.${index + 1}`)}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default StepWorkshop;
